import { createSlice } from "@reduxjs/toolkit";
import {
  MonitorSliceState,
  ProcessInstance,
  ProcessInstanceDetails,
  ProcessInstanceInfo,
} from "./monitor-interface";
import {
  fetchProcessInstanceByUuid,
  fetchProcessInstances,
  triggerProcessExecution,
} from "./monitor-async-calls";

const initialState: MonitorSliceState = {
  processInstanceUuid: "",
  processIntances: [],
  selectedProcessInstance: null,
  isFetching: false,
  monitorPageNumber: 0,
  rowsPerPage: 10,
  totalPages: 1,
  processInstanceInfo: undefined,
  processInstanceNodeInfo: undefined,
  processInstanceVariablesInfo: [],
  filters: {
    search: "",
    status: [],
    startedBy: "",
    processModel: "",
    timeRange: "",
  },
};

const monitorSlice = createSlice({
  name: "monitor",
  initialState,
  reducers: {
    setPageNumber(state, action: { payload: number }) {
      state.monitorPageNumber = action.payload;
    },
    setRowsPerpage(state, action: { payload: number }) {
      state.rowsPerPage = action.payload;
    },
    setTotalPages(state, action: { payload: number }) {
      state.totalPages = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessInstances.pending, (state) => {
        state.processIntances = [];
        state.isFetching = true;
      })
      .addCase(fetchProcessInstances.fulfilled, (state, action) => {
        state.processIntances = action.payload.content as ProcessInstance[];
        state.totalPages = action.payload.totalPages;
        state.isFetching = false;
      })
      .addCase(fetchProcessInstances.rejected, (state) => {
        state.processIntances = [];
        state.isFetching = false;
      })
      .addCase(fetchProcessInstanceByUuid.pending, (state) => {
        state.processInstanceInfo = undefined;
        state.isFetching = true;
      })
      .addCase(fetchProcessInstanceByUuid.fulfilled, (state, action) => {
        state.processInstanceInfo = action.payload as ProcessInstanceInfo;
        state.isFetching = false;
      })
      .addCase(fetchProcessInstanceByUuid.rejected, (state) => {
        state.processInstanceInfo = undefined;
        state.isFetching = false;
      })
      .addCase(triggerProcessExecution.pending, (state) => {
        state.processInstanceNodeInfo = undefined;
        state.processInstanceVariablesInfo = [];
        state.isFetching = true;
      })
      .addCase(triggerProcessExecution.fulfilled, (state, action) => {
        const response = action.payload as ProcessInstanceDetails;
        state.processInstanceNodeInfo = response.processInstanceNodeInfo;
        state.processInstanceVariablesInfo =
          response.processInstanceVariablesInfo;
        state.isFetching = false;
      })
      .addCase(triggerProcessExecution.rejected, (state) => {
        state.processInstanceNodeInfo = undefined;
        state.processInstanceVariablesInfo = [];
        state.isFetching = false;
      });
  },
});

export const { setPageNumber, setRowsPerpage, setTotalPages, setFilters } =
  monitorSlice.actions;

export default monitorSlice.reducer;
